import { SportsbookVm } from './SportsbookVm';
import { currencyFormatter } from '../helper/currencyFormatter';

export class SportsbookComparisonItemVm {
    sportsbookVm: SportsbookVm;
    toWin: number;
    odds: string | null; // Only set for parlays

    constructor(sportsbookVm: SportsbookVm, toWin: number, odds: string | null = null) {
        this.sportsbookVm = sportsbookVm;
        this.toWin = toWin;
        this.odds = odds;
    }

    // Method for displaying the toWin amount with the currency.. example: $42.49
    getFormattedWinnings(): string {
        return currencyFormatter.format(this.toWin);
    }

    // Method for displaying the odds
    getFormattedOdds(): string {
        return this.odds ? this.odds : "Odds not available";
    }
}
